import React from 'react';
import AuthService from './authService';
import TpWaveItem from '../Domain/TpWaveItem';
import ProjectAssociableTpWaveItem from '../Domain/ThirdParty/Project/ProjectAssociableTpWaveItem';
import SearchParams from '../Elements/SearchParams';
import TpWaveSearchParams from '../Contents/ThirdParty/TpWave/TpWaveSearchParams';

export default class TpWaveService extends React.Component {
  static GetTpWaveItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpWaveSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/TpWave/GetItems?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetWaveSelectList(clientId) {
    const url = `/api/TpWave/GetWaveSelectList?clientId=${clientId}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static RemoveWaveAssociation(item) {
    const authService = AuthService.getInstance();
    const url = '/api/TpWave/RemoveWaveAssociation/';
    const dataJson = JSON.stringify(item);

    return authService.CallBackendFunctionPut(url, dataJson);
  }

  static AssociateProjectTpWave(item) {
    const url = '/api/TpWave/AssociateProjectTpWave';
    return AuthService.getInstance().CallBackendFunctionPost(url, item);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpWaveItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertToProjectAssociableTpWaveItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ProjectAssociableTpWaveItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
